import { InviteTeam } from '@/components/team-management/invite-team/invite-team';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(onboarding)/invite-team')({
  component: RouteComponent,
});

function RouteComponent() {
  return <InviteTeam />;
}
